export default {"src":"https://cdn.tanzhi.cn/_next/static/media/post.ed96a319.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};